import { actionTypes } from 'common/actionTypes';

export function reset_error() {
    return {
        type: actionTypes.global.RESET_ERROR, 
        payload: null
    };
    
}
